import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import FlagCanadaIcon from './FlagCanadaIcon';
import FlagUnitedStatesAmericaIcon from './FlagUnitedStatesAmericaIcon';
import FlagGenericIcon from './FlagGenericIcon';

const styles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
        paddingLeft: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    title: {
        flex: '0 0 auto',
    },
    currencies: {
        borderLeft: '1px solid #959595',
        borderRadius: 4,
        height: 48,
        [theme.breakpoints.up('sm')]: {
            borderRadius: 8,
        },
    },
});

//const ITEM_HEIGHT = 48;

class SuccessPaymentInvoiceToolBar extends Component {

    constructor(props) {
        super(props);       
    }



    render() {
        const { classes} = this.props;
        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: 0,
                })}
            >
                <div className={classes.title}>
                        <Typography variant="title" id="tableTitle">
                        Invoice Amount
                        </Typography>
                </div>               
            </Toolbar>
        );
    }
};

SuccessPaymentInvoiceToolBar.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array,
};

export default withStyles(styles)(SuccessPaymentInvoiceToolBar);


// WEBPACK FOOTER //
// ./src/SuccessPaymentInvoiceToolBar.js